"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MicroTestMethod = exports.DataHandleOption = exports.ApprovalStatus = exports.UserStatus = exports.Severity = exports.LicenseType = exports.LicenseDesignation = exports.LicenseOption = exports.DBAction = exports.WeightUnit = exports.FrontendProfileTab = exports.FrontendTestOptionTab = exports.FrontendContentPage = exports.OrderStatus = exports.FrontendTestBatchStatusFilter = exports.FrontendInstanceTestStatusFilter = exports.TestStatus = exports.FrontendTurnaroundTimeOptions = exports.TurnaroundTime = exports.TestPackages = exports.CannabisSampleCategory = exports.StaphylococcusCustomOption = exports.EColiCustomOption = exports.SalmonCustomOption = exports.BTGNCustomOption = exports.OtherSubMatrix = exports.AccessoriesSubMatrix = exports.PhysicalConcentrateExtractSubMatrix = exports.ChemicalConcentrateExtractSubMatrix = exports.TopicalsSubMatrix = exports.ConsumablesSubMatrix = exports.FreshCannabisSubMatrix = exports.HempSubMatrix = exports.DriedCannabisSubMatrix = exports.SampleMatrix = exports.ReceivingCondition = exports.SystemRole = exports.VALIDATION_RADIO_GROUP_OPTIONS = exports.SPECIFICATION_ALLOWED_MIME_TYPES = exports.REPORT_ALLOWED_MIME_TYPES = exports.MAX_COMMENT_LENGTH = exports.COMPANY_SPECIFICATION_SIZE_LIMIT = exports.SPECIFICATION_FILE_SIZE_LIMIT = exports.REPORT_FILE_SIZE_LIMIT = exports.ONE_DAY_IN_SECONDS = exports.ONE_HOUR_IN_SECONDS = exports.ONE_DAY_IN_MS = exports.ONE_HOUR_IN_MS = exports.ONE_MINUTE_IN_MS = exports.ONE_SECOND_IN_MS = void 0;
exports.NotificationType = exports.SpecHeaderType = exports.SystemAddOn = exports.RenderHideOption = exports.FunctionOperand = exports.FormulaComponentType = exports.ConditionOperand = exports.LogicOperand = exports.ConditionNodeType = exports.TestingWorkflowFieldType = exports.TestingWorkflowInfoType = exports.TestingWorkflowInfoHierarchyNodeType = exports.WorkflowTransitionTriggerType = exports.WorkflowStepType = exports.WorkflowType = exports.TestExpectationUnit = exports.ExpectationFieldType = exports.CompanyTestResultFieldType = exports.SecondaryCompanyLabelType = exports.CompanyLabelType = exports.AdditionalInfoFieldType = exports.AdditionalInfoType = exports.AnalystGroupActionType = exports.TestHierarchyNodeType = exports.BatchStatus = exports.AdminViewOrderWrapperPage = void 0;
exports.ONE_SECOND_IN_MS = 1000;
exports.ONE_MINUTE_IN_MS = exports.ONE_SECOND_IN_MS * 60;
exports.ONE_HOUR_IN_MS = exports.ONE_MINUTE_IN_MS * 60;
exports.ONE_DAY_IN_MS = exports.ONE_HOUR_IN_MS * 24;
exports.ONE_HOUR_IN_SECONDS = 3600;
exports.ONE_DAY_IN_SECONDS = 24 * exports.ONE_HOUR_IN_SECONDS;
exports.REPORT_FILE_SIZE_LIMIT = 1 * 1024 * 1024; // 1 MB
exports.SPECIFICATION_FILE_SIZE_LIMIT = 1 * 1024 * 1024; //1 MB
exports.COMPANY_SPECIFICATION_SIZE_LIMIT = 1024 * exports.SPECIFICATION_FILE_SIZE_LIMIT;
exports.MAX_COMMENT_LENGTH = 300;
exports.REPORT_ALLOWED_MIME_TYPES = [
    "application/pdf", // PDF
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
    "application/rtf", // RTF
    "text/plain", // TXT
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
    "text/csv", // CSV
    "text/html", // HTML
    "image/png", // PNG
    "image/jpeg", // JPEG
    "application/xml", // XML
];
exports.SPECIFICATION_ALLOWED_MIME_TYPES = [
    "application/pdf", // PDF
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // DOCX
    "application/rtf", // RTF
    "text/plain", // TXT
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
    "text/csv", // CSV
    "text/html", // HTML
    "image/png", // PNG
    "image/jpeg", // JPEG
    "application/xml", // XML
];
exports.VALIDATION_RADIO_GROUP_OPTIONS = ["Yes", "No", "N/A"];
var SystemRole;
(function (SystemRole) {
    //L1
    SystemRole["SYSTEM_ADMIN"] = "system admin";
    //L2
    SystemRole["ADMIN"] = "admin";
    SystemRole["LAB_MANAGER"] = "lab_manager";
    //READ AND ADD ACCESS TO CLIENTS AND ORDERS, NO MODIFY ACCESS TO ORDERS
    SystemRole["RECEPTIONIST"] = "receptionist";
    //READ ACCESS TO CLIENTS AND ORDER INFO
    SystemRole["SALES_REP"] = "sales_rep";
    //READ ACCESS TO INSTANCE AND BATCHES
    SystemRole["ANALYST"] = "analyst";
})(SystemRole || (exports.SystemRole = SystemRole = {}));
var ReceivingCondition;
(function (ReceivingCondition) {
    ReceivingCondition["AMBIENT"] = "Ambient";
    ReceivingCondition["IN_COOLER"] = "In cooler";
    ReceivingCondition["OTHER"] = "Other";
})(ReceivingCondition || (exports.ReceivingCondition = ReceivingCondition = {}));
var SampleMatrix;
(function (SampleMatrix) {
    SampleMatrix["DRIED_CANNABIS"] = "Dried Cannabis";
    SampleMatrix["HEMP"] = "Hemp";
    SampleMatrix["FRESH_CANNABIS"] = "Fresh Cannabis";
    SampleMatrix["CONSUMABLES"] = "Consumables";
    SampleMatrix["TOPICALS"] = "Topicals";
    SampleMatrix["CHEMICAL_CONCENTRATE_EXTRACT"] = "Chemically Concentrated Extracts";
    SampleMatrix["PHYSICAL_CONCENTRATE_EXTRACT"] = "Physically Concentrated Extracts";
    SampleMatrix["ACCESSORIES"] = "Accessories";
    SampleMatrix["OTHER"] = "Other";
})(SampleMatrix || (exports.SampleMatrix = SampleMatrix = {}));
var DriedCannabisSubMatrix;
(function (DriedCannabisSubMatrix) {
    DriedCannabisSubMatrix["FLOWER"] = "Dried Cannabis - Flower";
    DriedCannabisSubMatrix["INFUSED_FLOWER"] = "Dried Cannabis - Flower(infused)";
    DriedCannabisSubMatrix["MILLED"] = "Dried Cannabis - Milled";
    DriedCannabisSubMatrix["INFUSED_MILLED"] = "Dried Cannabis - Milled(infused)";
    DriedCannabisSubMatrix["PRE_ROLL"] = "Dried Cannabis - Pre-roll";
    DriedCannabisSubMatrix["INFUSED_PRE_ROLL"] = "Dried Cannabis - Pre-roll(infused)";
    DriedCannabisSubMatrix["SHAKE"] = "Dried Cannabis - Shake";
    DriedCannabisSubMatrix["TRIM"] = "Dried Cannabis - Trim";
    DriedCannabisSubMatrix["NOT_SPECIFIED"] = "Dried Cannabis - Not Specified";
})(DriedCannabisSubMatrix || (exports.DriedCannabisSubMatrix = DriedCannabisSubMatrix = {}));
var HempSubMatrix;
(function (HempSubMatrix) {
    HempSubMatrix["HEMP"] = "Hemp";
    HempSubMatrix["NOT_SPECIFIED"] = "Hemp - Not Specified";
})(HempSubMatrix || (exports.HempSubMatrix = HempSubMatrix = {}));
var FreshCannabisSubMatrix;
(function (FreshCannabisSubMatrix) {
    FreshCannabisSubMatrix["FLOWER"] = "Fresh Cannabis - Flower";
    FreshCannabisSubMatrix["LEAF"] = "Fresh Cannabis - Leaf";
    FreshCannabisSubMatrix["ROOT"] = "Fresh Cannabis - Root";
    FreshCannabisSubMatrix["NOT_SPECIFIED"] = "Fresh Cannabis - Not Specified";
})(FreshCannabisSubMatrix || (exports.FreshCannabisSubMatrix = FreshCannabisSubMatrix = {}));
var ConsumablesSubMatrix;
(function (ConsumablesSubMatrix) {
    ConsumablesSubMatrix["CANNABIS_OIL"] = "Consumables - Cannabis Oil";
    ConsumablesSubMatrix["SPRAYS"] = "Consumables - Sprays";
    ConsumablesSubMatrix["TINCTURES"] = "Consumables - Tinctures";
    ConsumablesSubMatrix["BEVERAGE"] = "Consumables - Beverage";
    ConsumablesSubMatrix["EDIBLES"] = "Consumables - Edibles";
    ConsumablesSubMatrix["CAPSULES"] = "Consumables - Capsules";
    ConsumablesSubMatrix["NOT_SPECIFIED"] = "Consumables - Not Specified";
})(ConsumablesSubMatrix || (exports.ConsumablesSubMatrix = ConsumablesSubMatrix = {}));
var TopicalsSubMatrix;
(function (TopicalsSubMatrix) {
    TopicalsSubMatrix["CREAMS"] = "Topicals - Creams";
    TopicalsSubMatrix["LINIMENTS"] = "Topicals - Liniments";
    TopicalsSubMatrix["SALVES"] = "Topicals - Salves";
    TopicalsSubMatrix["NOT_SPECIFIED"] = "Topicals - Not Specified";
})(TopicalsSubMatrix || (exports.TopicalsSubMatrix = TopicalsSubMatrix = {}));
var ChemicalConcentrateExtractSubMatrix;
(function (ChemicalConcentrateExtractSubMatrix) {
    ChemicalConcentrateExtractSubMatrix["BADDER"] = "Chemically Concentrated Extracts - Badder";
    ChemicalConcentrateExtractSubMatrix["LIVE_BADDER"] = "Chemically Concentrated Extracts - Badder(Live)";
    ChemicalConcentrateExtractSubMatrix["DIAMONDS"] = "Chemically Concentrated Extracts - Diamonds";
    ChemicalConcentrateExtractSubMatrix["DISTILLATE"] = "Chemically Concentrated Extracts - Distillate";
    ChemicalConcentrateExtractSubMatrix["HASH_OIL"] = "Chemically Concentrated Extracts - Hash Oil";
    ChemicalConcentrateExtractSubMatrix["ISOLATE"] = "Chemically Concentrated Extracts - Isolate";
    ChemicalConcentrateExtractSubMatrix["RESIN"] = "Chemically Concentrated Extracts - Resin";
    ChemicalConcentrateExtractSubMatrix["LIVE_RESIN"] = "Chemically Concentrated Extracts - Live Resin";
    ChemicalConcentrateExtractSubMatrix["SHATTER"] = "Chemically Concentrated Extracts - Shatter";
    ChemicalConcentrateExtractSubMatrix["WAX"] = "Chemically Concentrated Extracts - Wax";
    ChemicalConcentrateExtractSubMatrix["NOT_SPECIFIED"] = "Chemically Concentrated Extracts - Not Specified";
})(ChemicalConcentrateExtractSubMatrix || (exports.ChemicalConcentrateExtractSubMatrix = ChemicalConcentrateExtractSubMatrix = {}));
var PhysicalConcentrateExtractSubMatrix;
(function (PhysicalConcentrateExtractSubMatrix) {
    PhysicalConcentrateExtractSubMatrix["HASH"] = "Physically Concentrated Extracts - Hash";
    PhysicalConcentrateExtractSubMatrix["DRY_SIFT_HASH"] = "Physically Concentrated Extracts - Hash(Dry Sift)";
    PhysicalConcentrateExtractSubMatrix["KIEF"] = "Physically Concentrated Extracts - Kief";
    PhysicalConcentrateExtractSubMatrix["PRESSED_KIEF"] = "Physically Concentrated Extracts - Kief(Pressed)";
    PhysicalConcentrateExtractSubMatrix["ROSIN"] = "Physically Concentrated Extracts - Rosin";
    PhysicalConcentrateExtractSubMatrix["FLOWER_ROSIN"] = "Physically Concentrated Extracts - Rosin(Flower)";
    PhysicalConcentrateExtractSubMatrix["HASH_ROSIN"] = "Physically Concentrated Extracts - Rosin(Hash)";
    PhysicalConcentrateExtractSubMatrix["LIVE_ROSIN"] = "Physically Concentrated Extracts - Rosin(Live)";
    PhysicalConcentrateExtractSubMatrix["NOT_SPECIFIED"] = "Physically Concentrated Extracts - Not Specified";
})(PhysicalConcentrateExtractSubMatrix || (exports.PhysicalConcentrateExtractSubMatrix = PhysicalConcentrateExtractSubMatrix = {}));
var AccessoriesSubMatrix;
(function (AccessoriesSubMatrix) {
    AccessoriesSubMatrix["ROLLING_PAPER"] = "Accessories - Rolling Paper";
    AccessoriesSubMatrix["NOT_SPECIFIED"] = "Accessories - Not Specified";
})(AccessoriesSubMatrix || (exports.AccessoriesSubMatrix = AccessoriesSubMatrix = {}));
var OtherSubMatrix;
(function (OtherSubMatrix) {
    OtherSubMatrix["SOLID"] = "Other - Solid";
    OtherSubMatrix["INHALABLE"] = "Other - Inhalable";
    OtherSubMatrix["LIQUID"] = "Other - Liquid";
    OtherSubMatrix["NOT_SPECIFIED"] = "Other - Not Specified";
})(OtherSubMatrix || (exports.OtherSubMatrix = OtherSubMatrix = {}));
var BTGNCustomOption;
(function (BTGNCustomOption) {
    BTGNCustomOption["OneGram"] = "1g";
    BTGNCustomOption["CFU"] = "CFU/g";
})(BTGNCustomOption || (exports.BTGNCustomOption = BTGNCustomOption = {}));
var SalmonCustomOption;
(function (SalmonCustomOption) {
    SalmonCustomOption["TwentyFiveGram"] = "25g";
    SalmonCustomOption["TenGram"] = "10g";
})(SalmonCustomOption || (exports.SalmonCustomOption = SalmonCustomOption = {}));
var EColiCustomOption;
(function (EColiCustomOption) {
    EColiCustomOption["OneGram"] = "1g";
    EColiCustomOption["TenGram"] = "10g";
})(EColiCustomOption || (exports.EColiCustomOption = EColiCustomOption = {}));
var StaphylococcusCustomOption;
(function (StaphylococcusCustomOption) {
    StaphylococcusCustomOption["OneGram"] = "1g";
    StaphylococcusCustomOption["TenGram"] = "10g";
})(StaphylococcusCustomOption || (exports.StaphylococcusCustomOption = StaphylococcusCustomOption = {}));
var CannabisSampleCategory;
(function (CannabisSampleCategory) {
    CannabisSampleCategory["FLOWER"] = "Flower";
    CannabisSampleCategory["HYBRID"] = "Hybrid";
    CannabisSampleCategory["OIL"] = "Oil";
    CannabisSampleCategory["OTHER"] = "Other";
})(CannabisSampleCategory || (exports.CannabisSampleCategory = CannabisSampleCategory = {}));
var TestPackages;
(function (TestPackages) {
    TestPackages["QAP_FLOWER"] = "QualityAssurancePackageFlower";
    TestPackages["HCP_FLOWER"] = "HealthCanadaPackageFlower";
    TestPackages["CTP_FLOWER"] = "CompleteTestingPackageFlower";
    TestPackages["QAP_OIL"] = "QualityAssurancePackageOil";
    TestPackages["HCP_OIL"] = "HealthCanadaPackageOil";
    TestPackages["CTP_OIL"] = "CompleteTestingPackageOil";
    TestPackages["QAP_HYBRID"] = "QualityAssurancePackageHybrid";
    TestPackages["HCP_HYBRID"] = "HealthCanadaPackageHybrid";
    TestPackages["CTP_HYBRID"] = "CompleteTestingPackageHybrid";
    TestPackages["CUSTOM_FLOWER"] = "CustomPackageFlower";
    TestPackages["CUSTOM_OIL"] = "CustomPackageOil";
    TestPackages["CUSTOM_HYBRID"] = "CustomPackageHybrid";
})(TestPackages || (exports.TestPackages = TestPackages = {}));
var TurnaroundTime;
(function (TurnaroundTime) {
    TurnaroundTime["STANDARD"] = "StandardTAT";
    TurnaroundTime["RUSH"] = "RushTAT";
    TurnaroundTime["URGENT"] = "UrgentTAT";
    TurnaroundTime["SAMEDAY"] = "SameDayTAT";
})(TurnaroundTime || (exports.TurnaroundTime = TurnaroundTime = {}));
var FrontendTurnaroundTimeOptions;
(function (FrontendTurnaroundTimeOptions) {
    FrontendTurnaroundTimeOptions["STANDARD"] = "StandardTATDescription";
    FrontendTurnaroundTimeOptions["RUSH"] = "RushTATDescription";
    FrontendTurnaroundTimeOptions["URGENT"] = "UrgentTATDescription";
    FrontendTurnaroundTimeOptions["SAMEDAY"] = "SameDayTATDescription";
})(FrontendTurnaroundTimeOptions || (exports.FrontendTurnaroundTimeOptions = FrontendTurnaroundTimeOptions = {}));
var TestStatus;
(function (TestStatus) {
    TestStatus["SAMPLE_REGISTERED"] = "Sample Registered";
    TestStatus["IN_TESTING"] = "In Testing";
    TestStatus["REPORT_READY"] = "Report Ready";
})(TestStatus || (exports.TestStatus = TestStatus = {}));
var FrontendInstanceTestStatusFilter;
(function (FrontendInstanceTestStatusFilter) {
    FrontendInstanceTestStatusFilter["IN_PROGRESS"] = "In Progress";
    FrontendInstanceTestStatusFilter["COMPLETE"] = "Complete";
    FrontendInstanceTestStatusFilter["ALL"] = "";
})(FrontendInstanceTestStatusFilter || (exports.FrontendInstanceTestStatusFilter = FrontendInstanceTestStatusFilter = {}));
var FrontendTestBatchStatusFilter;
(function (FrontendTestBatchStatusFilter) {
    FrontendTestBatchStatusFilter["IN_PROGRESS"] = "In Progress";
    FrontendTestBatchStatusFilter["COMPLETE"] = "Complete";
    FrontendTestBatchStatusFilter["ALL"] = "";
})(FrontendTestBatchStatusFilter || (exports.FrontendTestBatchStatusFilter = FrontendTestBatchStatusFilter = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["IN_PROGRESS"] = "In Progress";
    OrderStatus["COMPLETE"] = "Complete";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var FrontendContentPage;
(function (FrontendContentPage) {
    FrontendContentPage["NEW_ORDER_PAGE"] = "NewOrderPage";
    FrontendContentPage["VIEW_ORDER_PAGE"] = "ViewOrderPage";
    FrontendContentPage["USER_INFO_PAGE"] = "UserInfoPage";
    FrontendContentPage["CLIENTS_PAGE"] = "ClientsPage";
    FrontendContentPage["ORDER_DETAILS_PAGE"] = "OrderDetailsPage";
    //testing pages
    FrontendContentPage["INSTANCE_PAGE"] = "InstancePage";
    FrontendContentPage["INSTANCE_DETAILS_PAGE"] = "InstanceDetailsPage";
    FrontendContentPage["BATCH_PAGE"] = "BatchPage";
    FrontendContentPage["BATCH_DETAILS_PAGE"] = "BatchDetailsPage";
    FrontendContentPage["BATCH_GENERATION_PAGE"] = "BatchGenerationPage";
    //admins
    FrontendContentPage["ROSTER_PAGE"] = "RosterPage";
    FrontendContentPage["LOG_PAGE"] = "LogPage";
    FrontendContentPage["FILE_PASSWORD"] = "FilePasswordPage";
    FrontendContentPage["LAB_STRUCTURE"] = "LabStructure";
})(FrontendContentPage || (exports.FrontendContentPage = FrontendContentPage = {}));
var FrontendTestOptionTab;
(function (FrontendTestOptionTab) {
    FrontendTestOptionTab["CHEMICAL"] = "Chemical";
    FrontendTestOptionTab["MICRO"] = "Micro";
    FrontendTestOptionTab["ADDITIONAL"] = "Additional";
})(FrontendTestOptionTab || (exports.FrontendTestOptionTab = FrontendTestOptionTab = {}));
var FrontendProfileTab;
(function (FrontendProfileTab) {
    FrontendProfileTab["PROFILE"] = "Profile";
    FrontendProfileTab["LICENSE"] = "License";
    FrontendProfileTab["BILLING"] = "Billing";
    FrontendProfileTab["SPECIFICATIONS"] = "Specifications";
})(FrontendProfileTab || (exports.FrontendProfileTab = FrontendProfileTab = {}));
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["ML"] = "ml";
    WeightUnit["GRAMS"] = "g";
})(WeightUnit || (exports.WeightUnit = WeightUnit = {}));
var DBAction;
(function (DBAction) {
    DBAction["INSERT"] = "insert";
    DBAction["UPDATE"] = "update";
    DBAction["DELETE"] = "delete";
    DBAction["UPSERT"] = "upsert";
})(DBAction || (exports.DBAction = DBAction = {}));
var LicenseOption;
(function (LicenseOption) {
    LicenseOption["SELECT_LICENSE"] = "SelectLicense";
    LicenseOption["ADD_LICENSE"] = "AddLicense";
    LicenseOption["NO_LICENSE"] = "NoLicense";
})(LicenseOption || (exports.LicenseOption = LicenseOption = {}));
var LicenseDesignation;
(function (LicenseDesignation) {
    LicenseDesignation["MEDICAL"] = "Medical";
    LicenseDesignation["ADULT_USE"] = "AdultUse";
    LicenseDesignation["HEMP"] = "Hemp";
    LicenseDesignation["OTHER"] = "Other";
})(LicenseDesignation || (exports.LicenseDesignation = LicenseDesignation = {}));
var LicenseType;
(function (LicenseType) {
    LicenseType["LICENSED_PRODUCER"] = "LicensedProducer";
    LicenseType["MICRO_CULTIVATOR"] = "MicroCultivator";
    LicenseType["PERSONAL_MEDICAL_USE"] = "PersonalMedicalUse";
    LicenseType["RETAILER"] = "Retailer";
    LicenseType["LICENSED_PROCESSOR"] = "LicensedProcessor";
    LicenseType["OTHER"] = "Other";
})(LicenseType || (exports.LicenseType = LicenseType = {}));
var Severity;
(function (Severity) {
    Severity["SUCCESS"] = "success";
    Severity["ERROR"] = "error";
    Severity["INFO"] = "info";
    Severity["WARN"] = "warning";
})(Severity || (exports.Severity = Severity = {}));
var UserStatus;
(function (UserStatus) {
    UserStatus["PENDING_APPROVAL"] = "pending-approval";
    UserStatus["REGISTRATION_REJECTED"] = "registration-rejected";
    UserStatus["VALIDATING_EMAIL"] = "validating-email";
    UserStatus["REGISTERED"] = "registered";
})(UserStatus || (exports.UserStatus = UserStatus = {}));
var ApprovalStatus;
(function (ApprovalStatus) {
    ApprovalStatus["PENDING"] = "pending";
    ApprovalStatus["APPROVED"] = "approved";
    ApprovalStatus["REJECTED"] = "rejected";
})(ApprovalStatus || (exports.ApprovalStatus = ApprovalStatus = {}));
var DataHandleOption;
(function (DataHandleOption) {
    DataHandleOption["USE_IN_RECORD"] = "use-in-record";
    DataHandleOption["USE_NEW"] = "use-new";
})(DataHandleOption || (exports.DataHandleOption = DataHandleOption = {}));
var MicroTestMethod;
(function (MicroTestMethod) {
    MicroTestMethod["NOT_SPECIFIED"] = "Not Specified";
    MicroTestMethod["QPCR"] = "qPCR";
    MicroTestMethod["PLATE"] = "Plate Method";
})(MicroTestMethod || (exports.MicroTestMethod = MicroTestMethod = {}));
var AdminViewOrderWrapperPage;
(function (AdminViewOrderWrapperPage) {
    AdminViewOrderWrapperPage[AdminViewOrderWrapperPage["ORDER_DETAILS"] = 0] = "ORDER_DETAILS";
    AdminViewOrderWrapperPage[AdminViewOrderWrapperPage["EDIT_ORDER"] = 1] = "EDIT_ORDER";
    AdminViewOrderWrapperPage[AdminViewOrderWrapperPage["ORDER_REPORT"] = 2] = "ORDER_REPORT";
})(AdminViewOrderWrapperPage || (exports.AdminViewOrderWrapperPage = AdminViewOrderWrapperPage = {}));
var BatchStatus;
(function (BatchStatus) {
    BatchStatus["UNSTARTED"] = "Unstarted";
    BatchStatus["IN_PROGRESS"] = "In Progress";
    BatchStatus["PENDING_RESULT_VALIDATION"] = "Pending Result Validation";
    BatchStatus["COMPLETE"] = "Complete";
})(BatchStatus || (exports.BatchStatus = BatchStatus = {}));
var TestHierarchyNodeType;
(function (TestHierarchyNodeType) {
    TestHierarchyNodeType["ROOT"] = "Root";
    TestHierarchyNodeType["TEST_GROUP"] = "TestGroup";
    TestHierarchyNodeType["TEST_GROUP_OPTION_RADIO_GROUP"] = "TestGroupOptionRadioGroup";
    TestHierarchyNodeType["TEST_GROUP_OPTION_CHECKBOX_GROUP"] = "TestGroupOptionCheckboxGroup";
    TestHierarchyNodeType["TEST"] = "Test";
    TestHierarchyNodeType["TEST_OPTION_RADIO_GROUP"] = "TestOptionRadioGroup";
    TestHierarchyNodeType["TEST_ADDITIONAL_OPTION_GROUP"] = "TestAdditionalOptionGroup";
    TestHierarchyNodeType["RADIO_OPTION"] = "RadioOption";
    TestHierarchyNodeType["CHECKBOX_OPTION"] = "CheckboxOption";
})(TestHierarchyNodeType || (exports.TestHierarchyNodeType = TestHierarchyNodeType = {}));
var AnalystGroupActionType;
(function (AnalystGroupActionType) {
    AnalystGroupActionType["INDIVIDUAL_TO_INDIVIDUAL"] = "individual_to_individual";
    AnalystGroupActionType["INDIVIDUAL_TO_GROUP"] = "individual_to_group";
    AnalystGroupActionType["GROUP_TO_INDIVIDUAL"] = "group_to_individual";
    AnalystGroupActionType["GROUP_TO_GROUP"] = "group_to_group";
    AnalystGroupActionType["NO_OP"] = "no_op";
})(AnalystGroupActionType || (exports.AnalystGroupActionType = AnalystGroupActionType = {}));
var AdditionalInfoType;
(function (AdditionalInfoType) {
    AdditionalInfoType["SAMPLE"] = "Sample";
    AdditionalInfoType["SAMPLE_INSTANCE"] = "Instance";
})(AdditionalInfoType || (exports.AdditionalInfoType = AdditionalInfoType = {}));
var AdditionalInfoFieldType;
(function (AdditionalInfoFieldType) {
    AdditionalInfoFieldType["TEXT"] = "Text";
    AdditionalInfoFieldType["DATE"] = "Date";
})(AdditionalInfoFieldType || (exports.AdditionalInfoFieldType = AdditionalInfoFieldType = {}));
var CompanyLabelType;
(function (CompanyLabelType) {
    CompanyLabelType["X_TYPE_SAMPLE_ID_LABEL"] = "Cross Type Sample ID Label";
    CompanyLabelType["TEST_METHOD_LABEL"] = "Test Method Label";
    CompanyLabelType["MERGEABLE_TEST_METHOD_LABEL"] = "Mergeable Test Method Label";
    CompanyLabelType["CUSTOM"] = "Custom";
})(CompanyLabelType || (exports.CompanyLabelType = CompanyLabelType = {}));
var SecondaryCompanyLabelType;
(function (SecondaryCompanyLabelType) {
    SecondaryCompanyLabelType["FIXED_TEXT"] = "Fixed_Text";
    SecondaryCompanyLabelType["INPUT_SEQ_NUMERIC"] = "Input_Seq_Numeric";
    SecondaryCompanyLabelType["DILLUTION_AND_TEST_OPTION"] = "Dillution_Test_Option";
})(SecondaryCompanyLabelType || (exports.SecondaryCompanyLabelType = SecondaryCompanyLabelType = {}));
var CompanyTestResultFieldType;
(function (CompanyTestResultFieldType) {
    CompanyTestResultFieldType["NUMBER"] = "number";
    CompanyTestResultFieldType["TEXT"] = "text";
    CompanyTestResultFieldType["BOOLEAN"] = "boolean";
})(CompanyTestResultFieldType || (exports.CompanyTestResultFieldType = CompanyTestResultFieldType = {}));
var ExpectationFieldType;
(function (ExpectationFieldType) {
    ExpectationFieldType["RANGE"] = "range";
    ExpectationFieldType["VALUE"] = "value";
})(ExpectationFieldType || (exports.ExpectationFieldType = ExpectationFieldType = {}));
var TestExpectationUnit;
(function (TestExpectationUnit) {
    TestExpectationUnit["PERCENT"] = "%";
    TestExpectationUnit["MG_PER_G"] = "mg/g";
    TestExpectationUnit["MG_PER_ML"] = "mg/ml";
})(TestExpectationUnit || (exports.TestExpectationUnit = TestExpectationUnit = {}));
var WorkflowType;
(function (WorkflowType) {
    WorkflowType["INDIVIDUAL"] = "individual";
    WorkflowType["JOINT"] = "joint";
})(WorkflowType || (exports.WorkflowType = WorkflowType = {}));
var WorkflowStepType;
(function (WorkflowStepType) {
    WorkflowStepType["CONTAINER"] = "container";
    WorkflowStepType["DATA"] = "data";
    WorkflowStepType["RESULT"] = "result";
})(WorkflowStepType || (exports.WorkflowStepType = WorkflowStepType = {}));
var WorkflowTransitionTriggerType;
(function (WorkflowTransitionTriggerType) {
    WorkflowTransitionTriggerType["CONFIRM"] = "confirm";
    WorkflowTransitionTriggerType["REJECT"] = "reject";
})(WorkflowTransitionTriggerType || (exports.WorkflowTransitionTriggerType = WorkflowTransitionTriggerType = {}));
var TestingWorkflowInfoHierarchyNodeType;
(function (TestingWorkflowInfoHierarchyNodeType) {
    // ROOT = "Root",
    TestingWorkflowInfoHierarchyNodeType["BATCH_INFO_GROUP"] = "BatchInfoGroup";
    TestingWorkflowInfoHierarchyNodeType["INSTANCE_INFO_GROUP"] = "InstanceInfoGroup";
    TestingWorkflowInfoHierarchyNodeType["SUB_INFO_GROUP"] = "SubInfoGroup";
    //special
    TestingWorkflowInfoHierarchyNodeType["INSTANCE_ID_PLACEMENT"] = "InstanceIdPlacement";
    TestingWorkflowInfoHierarchyNodeType["RESULT_PLACEMENT"] = "ResultPlacement";
})(TestingWorkflowInfoHierarchyNodeType || (exports.TestingWorkflowInfoHierarchyNodeType = TestingWorkflowInfoHierarchyNodeType = {}));
var TestingWorkflowInfoType;
(function (TestingWorkflowInfoType) {
    TestingWorkflowInfoType["INSTANCE"] = "instance";
    TestingWorkflowInfoType["BATCH"] = "batch";
})(TestingWorkflowInfoType || (exports.TestingWorkflowInfoType = TestingWorkflowInfoType = {}));
var TestingWorkflowFieldType;
(function (TestingWorkflowFieldType) {
    TestingWorkflowFieldType["TEXT_INPUT"] = "TextInput";
    TestingWorkflowFieldType["NUMERIC_INPUT"] = "NumericInput";
    TestingWorkflowFieldType["DROPDOWN_INPUT"] = "DropdownInput";
    TestingWorkflowFieldType["CHECKBOX_GROUP"] = "CheckboxGroup";
    TestingWorkflowFieldType["DATETIME_INPUT"] = "DatetimeInput";
    TestingWorkflowFieldType["VALIDATION_RADIO_GROUP"] = "ValidationRadioGroup";
})(TestingWorkflowFieldType || (exports.TestingWorkflowFieldType = TestingWorkflowFieldType = {}));
var ConditionNodeType;
(function (ConditionNodeType) {
    ConditionNodeType["ONE_LINE_CONDITION"] = "one-line-condition";
    ConditionNodeType["OPERAND"] = "operand";
})(ConditionNodeType || (exports.ConditionNodeType = ConditionNodeType = {}));
var LogicOperand;
(function (LogicOperand) {
    LogicOperand["AND"] = "and";
    LogicOperand["OR"] = "or";
    LogicOperand["NOT"] = "not";
})(LogicOperand || (exports.LogicOperand = LogicOperand = {}));
var ConditionOperand;
(function (ConditionOperand) {
    ConditionOperand["EQ"] = "EQ";
    ConditionOperand["NE"] = "not-NE";
    ConditionOperand["GT"] = "GT";
    ConditionOperand["LT"] = "LT";
    ConditionOperand["GTE"] = "GTE";
    ConditionOperand["LTE"] = "LTE";
    ConditionOperand["EXISTS"] = "EXISTS";
    ConditionOperand["NOT_EXIST"] = "NOT_EXIST";
})(ConditionOperand || (exports.ConditionOperand = ConditionOperand = {}));
var FormulaComponentType;
(function (FormulaComponentType) {
    //values
    FormulaComponentType["FIELD"] = "field";
    FormulaComponentType["OPTION"] = "option";
    FormulaComponentType["CONSTANT"] = "constant";
    //operators
    FormulaComponentType["MATH"] = "math";
    FormulaComponentType["COMPARE"] = "compare";
    FormulaComponentType["LOGIC"] = "logic";
    FormulaComponentType["FUNCTION"] = "function";
    FormulaComponentType["IFELSE"] = "ifelse";
})(FormulaComponentType || (exports.FormulaComponentType = FormulaComponentType = {}));
var FunctionOperand;
(function (FunctionOperand) {
    FunctionOperand["MAX"] = "MAX";
    FunctionOperand["AVG"] = "AVG";
    FunctionOperand["AVG_IF_VALID_POSITIVE"] = "AVG_IF_VALID_POSITIVE";
    FunctionOperand["REPLACE_IF_LESS_THAN"] = "REPLACE_IF_LESS_THAN";
})(FunctionOperand || (exports.FunctionOperand = FunctionOperand = {}));
var RenderHideOption;
(function (RenderHideOption) {
    RenderHideOption["HIDE"] = "hide";
    RenderHideOption["DISABLE"] = "disable";
})(RenderHideOption || (exports.RenderHideOption = RenderHideOption = {}));
var SystemAddOn;
(function (SystemAddOn) {
    SystemAddOn["TEST_LABEL_PRINTING"] = "test_label_printing";
    SystemAddOn["CLIENT_PORTAL_INTEGRATION"] = "client_portal_integration";
    SystemAddOn["WORKFLOW_MANAGEMENT"] = "workflow_management";
    SystemAddOn["TEMP_PASSWORD_MANAGEMENT"] = "temp_password_management";
})(SystemAddOn || (exports.SystemAddOn = SystemAddOn = {}));
var SpecHeaderType;
(function (SpecHeaderType) {
    SpecHeaderType["SHORT_TEXT"] = "short_text";
    SpecHeaderType["LONG_TEXT"] = "long_text";
})(SpecHeaderType || (exports.SpecHeaderType = SpecHeaderType = {}));
var NotificationType;
(function (NotificationType) {
    NotificationType["NEW_WORKFLOW_COMMENT_NOTIFICAITON"] = "NewWorkflowCommentNotification";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
